import React, { useRef } from "react";
import { Search, X } from "lucide-react";
import "./searchbar.css";

/**
 * Reusable, premium SearchBar component with active glow borders,
 * dynamic search icon highlights, and an instant text-clearing 'X' button.
 */
function SearchBar({ value, onChange, placeholder = "Search...", width = "260px", className = "" }) {
  const inputRef = useRef(null);

  const handleClear = () => {
    if (onChange) {
      // Simulate input event to trigger standard parent handlers
      onChange({ target: { value: "" } });
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className={`modern-search-container ${className}`} style={{ width }}>
      <Search className="modern-search-icon" size={15} />
      <input
        ref={inputRef}
        type="text"
        className="modern-search-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {value && (
        <button className="modern-search-clear-btn" onClick={handleClear} aria-label="Clear search">
          <X size={13} />
        </button>
      )}
    </div>
  );
}

export default SearchBar;
